/**
 * This file is the entry point for the React app, it sets up the root
 * element and renders the App component to the DOM.
 *
 * It is included in `src/index.html`.
 */

import { createRoot } from "react-dom/client";
import { StrictMode } from "react";
import { App } from "./App";
import { ConvexAuthProvider } from "@convex-dev/auth/react";
import { ConvexReactClient } from "convex/react";

// P.S this does not work in production, so we need to use the direct URL
// import { CONVEX_HTTP_URL } from "./lib/env";

// const CONVEX_HTTP_URL = "http://127.0.0.1:3210";
const CONVEX_HTTP_URL = "https://blirumah-convex-cloud-3210.mylo.dev";

const convex = new ConvexReactClient(CONVEX_HTTP_URL, {
  verbose: true,
});

const elem = document.getElementById("root")!;
const app = (
  <StrictMode>
    <ConvexAuthProvider client={convex}>
      <App />
    </ConvexAuthProvider>
  </StrictMode>
);

if (import.meta.hot) {
  // With hot module reloading, `import.meta.hot.data` is persisted.
  const root = (import.meta.hot.data.root ??= createRoot(elem));
  root.render(app);
} else {
  // The hot module reloading API is not available in production.
  createRoot(elem).render(app);
}
